var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogOut(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 12L7 16V13H16V11H7V8L2 12Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0007 2.999C11.8182 2.99572 10.6469 3.22711 9.55447 3.67976C8.46206 4.13242 7.47032 4.79734 6.63672 5.636L8.05072 7.05C9.37272 5.728 11.1307 4.999 13.0007 4.999C14.8707 4.999 16.6287 5.728 17.9507 7.05C19.2727 8.372 20.0017 10.13 20.0017 12C20.0017 13.87 19.2727 15.628 17.9507 16.95C16.6287 18.272 14.8707 19.001 13.0007 19.001C11.1307 19.001 9.37272 18.272 8.05072 16.95L6.63672 18.364C8.33572 20.064 10.5957 21.001 13.0007 21.001C15.4057 21.001 17.6657 20.064 19.3647 18.364C21.0647 16.665 22.0017 14.405 22.0017 12C22.0017 9.595 21.0647 7.335 19.3647 5.636C18.5311 4.79734 17.5394 4.13242 16.447 3.67976C15.3546 3.22711 14.1832 2.99572 13.0007 2.999Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogOut);
export default __webpack_public_path__ + "static/media/log-out.f3c6712d8c2df9236b11df67b6eb8d7d.svg";
export { ForwardRef as ReactComponent };